/**
 * Original work Copyright (c) 2019 Burst Apps Team
 */

/**
 * Constants for smart contract (aka AT) subtypes
 *
 * @category transaction-types
 */
export enum TransactionSmartContractSubtype {
    SmartContractCreation = 0,
    SmartContractPayment
}

